import React from 'react';
import { Route } from 'react-router-dom';
import { AREA_CAPABILITIES } from '../areaCapabilities';
import {
  ComingSoon,
  MasterBudget,
  CreateTenantForm,
  TenantList,
  TenantAnalytics,
  DemoInvitationManager,
  DemoUsersManager,
  DemoRequestsManager,
  AccessDeveloperHub,
  ClientManager,
  DepartmentManager,
  RoleManager,
  EquipmentCatManager,
  EquipmentItemManager,
  UserManager,
  AccessCtrlMgr,
  BackupsPage,
  CompanyBackupPage,
} from '../lazyComponents';

/** Executive master views, platform superadmin, and ADM master data. */
export function ExecutivePlatformAdminRoutes({ withCapability, withAnyCapability }) {
  return (
    <>
      <Route path="/master-budget" element={withCapability(AREA_CAPABILITIES.financeMaster, <MasterBudget />)} />
      <Route
        path="/master-daily"
        element={withCapability(
          AREA_CAPABILITIES.financeMaster,
          <ComingSoon
            title="Master Daily"
            message="Consolidated daily view across Survey, Drilling, Recording and Base Camp will be available in a future release."
            roadmap={['Daily totals by area and cost type', 'Export to Excel / PDF', 'Link to Master Budget']}
          />,
        )}
      />
      <Route
        path="/master-summary"
        element={withCapability(
          AREA_CAPABILITIES.financeMaster,
          <ComingSoon
            title="Master Summary"
            message="Executive summary and high-level reporting across all project areas is planned for a future release."
            roadmap={['KPIs and variance vs budget', 'Summary by area and period', 'Dashboard-style overview']}
          />,
        )}
      />

      <Route
        path="/platform"
        element={withCapability(AREA_CAPABILITIES.platformDeveloper, <AccessDeveloperHub />)}
      />
      <Route path="/platform/new-company" element={withCapability(AREA_CAPABILITIES.platformDeveloper, <CreateTenantForm />)} />
      <Route path="/platform/companies" element={withCapability(AREA_CAPABILITIES.platformDeveloper, <TenantList />)} />
      <Route path="/platform/companies/:slug/analytics" element={withCapability(AREA_CAPABILITIES.platformDeveloper, <TenantAnalytics />)} />
      <Route
        path="/platform/demo-invitations"
        element={withCapability(AREA_CAPABILITIES.platformDeveloper, <DemoInvitationManager />)}
      />
      <Route
        path="/platform/demo-users"
        element={withCapability(AREA_CAPABILITIES.platformDeveloper, <DemoUsersManager />)}
      />
      <Route
        path="/platform/demo-requests"
        element={withCapability(AREA_CAPABILITIES.platformDeveloper, <DemoRequestsManager />)}
      />

      <Route
        path="/master-data/clients"
        element={withAnyCapability([AREA_CAPABILITIES.admin, AREA_CAPABILITIES.projects], <ClientManager />)}
      />
      <Route path="/master-data/departments" element={withCapability(AREA_CAPABILITIES.admin, <DepartmentManager />)} />
      <Route path="/master-data/roles" element={withCapability(AREA_CAPABILITIES.admin, <RoleManager />)} />
      <Route path="/master-data/equipment-categories" element={withCapability(AREA_CAPABILITIES.admin, <EquipmentCatManager />)} />
      <Route path="/master-data/equipment-items" element={withCapability(AREA_CAPABILITIES.admin, <EquipmentItemManager />)} />

      <Route path="/admin/users" element={withCapability(AREA_CAPABILITIES.admin, <UserManager />)} />
      <Route path="/access-control" element={withCapability(AREA_CAPABILITIES.admin, <AccessCtrlMgr />)} />

      {/* Backups — superadmin Global Backup + tenant Company Backup (R30 SWR for jobs/destinations).
          Backend enforces scope='global' as superadmin-only; the UI guard below uses admin.read so
          tenant admins reach /company/backups via the same capability bundle. */}
      <Route path="/admin/backups" element={withCapability(AREA_CAPABILITIES.admin, <BackupsPage />)} />
      <Route path="/company/backups" element={withCapability(AREA_CAPABILITIES.admin, <CompanyBackupPage />)} />
    </>
  );
}
